import { useEffect } from 'react';

/**
 * Sends the visitor straight on to an external URL.
 *
 * Used for short, brandable press links (e.g. /forbes) that we can print on
 * marketing material and keep pointing wherever we need to later.
 */
const ExternalRedirect = ({ to, label = 'article' }) => {
      useEffect(() => {
            window.location.replace(to);
      }, [to]);

      return (
            <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0b1120] px-6">
                  <div className="text-center">
                        <p className="text-slate-600 dark:text-slate-300 text-lg">
                              Taking you to the {label}&hellip;
                        </p>
                        <a
                              href={to}
                              className="mt-4 inline-block text-blue-600 dark:text-blue-400 underline underline-offset-4"
                        >
                              Continue if you are not redirected
                        </a>
                  </div>
            </div>
      );
};

export default ExternalRedirect;
